var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Invoice","collapse-action":""}},[_c('vue-ckeditor',{attrs:{"config":_vm.config},on:{"focus":function($event){return _vm.$emit('changed')}},model:{value:(_vm.html),callback:function ($$v) {_vm.html=$$v},expression:"html"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }